/**
 * API client para o módulo de Enquetes (Poll)
 */
import { apiService } from '@/services/api';
import type { PollState, PollResults, PollCreateRequest, PollVoteRequest } from '../types';

export const pollApi = {
    /**
     * Obtém a enquete ativa da mesa
     */
    getActivePoll: async (tableId: string): Promise<PollState> => {
        return await apiService.request<PollState>(`/modules/poll/table/${tableId}/active`, {
            method: 'GET'
        });
    },

    /**
     * Cria uma nova enquete
     */
    createPoll: async (tableId: string, data: PollCreateRequest): Promise<{ message: string; poll: any }> => {
        return await apiService.request(`/modules/poll/table/${tableId}/create`, {
            method: 'POST',
            body: JSON.stringify({
                question: data.question,
                options: data.options,
                poll_type: data.poll_type || 'single',
                is_anonymous: data.is_anonymous || false,
                show_results_live: data.show_results_live !== false
            })
        });
    },

    /**
     * Registra um voto
     */
    vote: async (pollId: string, data: PollVoteRequest): Promise<{ message: string; results: PollResults }> => {
        return await apiService.request(`/modules/poll/${pollId}/vote`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    /**
     * Obtém os resultados de uma enquete
     */
    getResults: async (pollId: string): Promise<PollResults> => {
        return await apiService.request<PollResults>(`/modules/poll/${pollId}/results`, {
            method: 'GET'
        });
    },

    /**
     * Encerra uma enquete
     */
    closePoll: async (pollId: string): Promise<{ message: string; results: PollResults }> => {
        return await apiService.request(`/modules/poll/${pollId}/close`, {
            method: 'POST'
        });
    }
};
